export default __webpack_public_path__ + "static/media/Flaticon.17cd5c76.eot";